<template>
  <BaseModal @close="$emit('close')" cardWidth="472px" noPadding noToolbar noExit>
    <template #default>
      <div class="w-full flex flex-col">
        <div class="w-full flex gap-3 px-5 pt-5 pb-2">
          <ConfirmPurchaseIcon class="text-icon-normal flex-shrink-0" />
          <div class="flex flex-col gap-1 pr-14">
            <BaseText type="label" size="sm" class="text-text-muted">
              Confirm API Subscription
            </BaseText>
            <BaseText type="body" size="sm" class="text-text-normal">
              You're about to subscribe to <span class="text-text-muted font-medium">{{ creditAmount.toLocaleString() }} Credits</span> for <span class="text-text-muted font-medium">${{ price.toLocaleString() }}/month.</span> Your plan will be charged immediately and credits will be available right away.
            </BaseText>
          </div>
        </div>
        <div class="w-full p-5">
          <button class="submit-btn w-full px-1.5 py-2 rounded-md"
          @click="confirmPurchase">
            <BaseText type="label" size="sm" class="text-white">
              Confirm
            </BaseText>
          </button>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import ConfirmPurchaseIcon from '../globals/Icons/ConfirmPurchaseIcon.vue'

export default {
  name: 'ConfirmCreditPurchaseModal',
  components: {
    ConfirmPurchaseIcon
  },
  props: {
    creditPackage: {
      type: Object,
      required: true
    },
    creditsMultiplier: {
      type: Number,
      default: 1
    }
  },
  computed: {
    creditAmount () {
      return this.creditPackage.creditQuantity * this.creditsMultiplier
    },
    price () {
      return this.creditPackage.monthlyPrice
    }
  },
  methods: {
    confirmPurchase () {
      this.$emit('confirm')
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
@property --submit-btn-opacity-1 {
syntax: '<number>';
initial-value: 0.12;
inherits: false;
}
@property --submit-btn-opacity-2 {
  syntax: '<number>';
  initial-value: 0.12;
  inherits: false;
}
.submit-btn {
  --submit-color: #121212;
  background: linear-gradient(180deg, rgba(255, 255, 255, var(--submit-btn-opacity-1)) 0%, rgba(255, 255, 255, var(--submit-btn-opacity-2)) 100%), var(--submit-color);
  color: white;
  box-shadow: 0px -1px 12px 0px rgba(255, 255, 255, 0.12) inset, 0px 0px 0px 1px var(--submit-color);
  transition: box-shadow 100ms ease-in-out,
    color 100ms ease-in-out, 
    background-color 100ms ease-in-out,
    --submit-btn-opacity-1 100ms ease-in-out, 
    --submit-btn-opacity-2 100ms ease-in-out,
    --submit-color 100ms ease-in-out;
}
.submit-btn:hover {
  --submit-btn-opacity-1: 0.24;
  --submit-btn-opacity-2: 0;
}
</style>